import "./dashboard-card.scss";

import { Skeleton } from "primereact/skeleton";

// Mirrors DashboardCard's layout so loading placeholders match the real card size
export function DashboardCardSkeleton() {
  return (
    <div className="dashboard-card">
      <div className="flex justify-between border p-4 sm:p-6 rounded-lg">
        <div className="flex-1 mr-4">
          <span className="block text-xs sm:text-sm">
            <Skeleton width="70%" height="0.8em" className="inline-block" />
          </span>
          <div className="text-lg sm:text-xl md:text-2xl">
            <Skeleton width="50%" height="0.8em" className="inline-block" />
          </div>
        </div>
        <div className="w-12 sm:w-14 md:w-16">
          <Skeleton width="100%" height="100%" borderRadius="0.5rem" />
        </div>
      </div>
    </div>
  );
}

export default DashboardCardSkeleton;
